import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PMOperationAdapter } from 'src/app/models/domain/adapters/pm-operation-adapter';
import { PMOrderOperation } from 'src/app/models/domain/pm-operation';
import {
  CollectionOfOperation,
  OperationSetService,
  YPMORDERSRVOperation,
} from 'src/generated-clients/order';

// TODO fix when https://github.com/oasis-tcs/odata-openapi/issues/61
interface ICountable extends CollectionOfOperation {
  __count: number;
}

@Injectable({
  providedIn: 'root',
})
export class PmOrderOperationDataService {
  private readonly orderNumberPropertyName: keyof YPMORDERSRVOperation = 'orderNumber';

  public constructor(
    private readonly pmOperationService: OperationSetService,
    private readonly operationAdapter: PMOperationAdapter
  ) {}

  public getPaginatedPMOperation(
    pmOrderIds: string[],
    { page, perPage }: { page: number; perPage: number }
  ): Observable<{ data: PMOrderOperation[]; total: number }> {
    const filter = pmOrderIds.map((x) => `${this.orderNumberPropertyName} eq '${x}'`).join(' or ');

    return this.pmOperationService
      .operationSetGet(perPage, page > 1 ? (page - 1) * perPage : undefined, filter, 'allpages', [
        'orderNumber',
        'activityNumber',
      ])
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          const d = res.d;
          const results = d?.results;

          if (d === undefined || results === undefined) {
            throw new Error('SAP Error');
          }

          return {
            data: results.map((result) => this.operationAdapter.adaptToDomain(result)),
            total: Number((d as ICountable).__count),
          };
        })
      );
  }
}
